import React from "react";
import styles from "./GameCityRewardsBanner.module.scss";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import botLeftSrc from 'images/Game City Rewards/bot_left_v2.png';
import botRightSrc from 'images/Game City Rewards/bot_right_v2.png';
import PricingFunctions from "common/PricingFunctions";

const GameCityRewardsBanner = ({ showTopRibbon = true, showBottomRibbon = false, showShopButton = true, color }) => {
    const pricing = useSelector(state => state.pricing);
    let countryCode = pricing.countryCode;
    const navigate = useNavigate();

    // Get regional pricing thresholds
    const localeLower = PricingFunctions.getRewardsLower(countryCode);
    const localeMid = PricingFunctions.getRewardsMid(countryCode);
    const currencySymbol = PricingFunctions.getCurrencySymbol(countryCode);

    const ribbonText = Array(10).fill("GAME.CITY REWARDS").map((text, index) => (
        <span key={index} className={styles.ribbonText}>
            {text} <span className={styles.dot}>•</span>
        </span>
    ));

    const isMobileWidth = () => {
        return window.innerWidth < 500;
    }

    return (
        <div className={`${styles.gameCityRewardsBanner} ${!showShopButton ? styles.noButton : ''}`} style={color ? { backgroundColor: color } : undefined}>
            <img className={`${styles.bot} ${styles.left}`} src={botLeftSrc} alt="bot-left" />
            <img className={`${styles.bot} ${styles.right}`} src={botRightSrc} alt="bot-right" />
            {showTopRibbon && !isMobileWidth() &&
                <div className={styles.ribbon}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }
            <h2 className={styles.title}> Create the perfect party night! </h2>
            <p className={styles.description}>
                Choose 3 or more games to get a 20% discount!
            </p>
            {/*<p className={styles.description}>*/}
            {/*    Get <b>{localeLower.discount}% OFF</b> on orders over {currencySymbol}{localeLower.amount} or <span className={styles.mobileBreak}><br /></span> <b>{localeMid.discount}% OFF</b> when you spend {currencySymbol}{localeMid.amount}+*/}
            {/*</p>*/}
            {showShopButton && <button onClick={() => navigate("/shop")} className={`${styles.button} ${styles.alternate} ${styles.wide}`}>SHOP & SAVE</button>}
            {showBottomRibbon &&
                <div className={`${styles.ribbon} ${styles.bottom}`}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }
        </div>
    );
};

export default GameCityRewardsBanner;